import { render, staticRenderFns } from "./ManagerBlock.vue?vue&type=template&id=459cceaa&scoped=true&"
import script from "./ManagerBlock.vue?vue&type=script&lang=ts&"
export * from "./ManagerBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ManagerBlock.vue?vue&type=style&index=0&id=459cceaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459cceaa",
  null
  
)

export default component.exports